/**
 * Zoomifyc
 * A jQuery plugin for img zoom effect.
 * http://celineWong7.github.io/zoomifyc
 *
 * (c) 2020 Wang Xiaolin - MIT
 */
var zoomifyc = {};

zoomifyc = {
	curImage: null, //  å½“å‰ç‚¹å‡»çš„å›¾ç‰‡ï¼ˆjqå¯¹è±¡ï¼‰
	curIndex: 0, // å½“å‰ç‚¹å‡»å›¾ç‰‡çš„ç´¢å¼•
	allImage: null, // $('#demo img') - æ‰€æœ‰å›¾ç‰‡å¯¹è±¡ï¼ˆjqå¯¹è±¡åˆ—è¡¨ï¼‰
	_img: null, // $(#zoomifycWrap .zoomifyc-img) - å¼¹çª—æ˜¾ç¤ºçš„å›¾ç‰‡å¯¹è±¡
	_content: null, // $(#zoomifycWrap .zoomifyc-content)
	isShow: false, // å¼¹çª—å·²æ‰“å¼€
	rotate: 0, // æ—‹è½¬è§’åº¦
	scale: 1, // æ”¾å¤§å€æ•°
	grabbing: false, // æ˜¯å¦æ‹–æ‹½ä¸­
	translateX: 0, // æ°´å¹³å¹³ç§» - æ‹–æ‹½
	translateY: 0, // åž‚ç›´å¹³ç§» - æ‹–æ‹½
	init: function(ele) {
		zoomifyc.createWrap();

		zoomifyc.allImage = ele;
		ele.addClass('zoomifyc').on('click',function(e){
			zoomifyc.curImage = $(this);
			zoomifyc.curIndex = zoomifyc.allImage.index(zoomifyc.curImage);
			zoomifyc.showWrap(zoomifyc.curImage.attr('src'));
		});

		zoomifyc.initMouseScroll(); // åˆå§‹åŒ–æ»šè½´-æ”¾å¤§ç¼©å°
		zoomifyc.initGrap(); // åˆå§‹åŒ–æ‹–æ‹½
		zoomifyc.initPageEvent(); // åˆå§‹åŒ–é¡µé¢ç›‘å¬äº‹ä»¶
	},
	reset: function(){
		zoomifyc.setTransform(1,0,0,0); // scale-1 rotate-0  translateX-0  translateY-0
	},
	createWrap: function() {
		if ($('#zoomifycWrap').length > 0) return;

		var $wrap = $('<div id="zoomifycWrap" style="display:none;"></div>'),
			$shadow = $('<div class="zoomifyc-shadow"></div>'),
			$content = $('<div class="zoomifyc-content"></div>'),
			$close = $('<span class="zoomifyc-close">x</span>'),
			$switchBtn = $('<div class="zoomifyc-switch"></div>'),
			$prev = $('<span class="prev">&lt;</span>'),
			$next = $('<span class="next">&gt;</span>'),
			$imgbox = $('<div class="zoomifyc-imgbox"></div>'),
			$img = $('<img class="zoomifyc-img" src="" >'),
			$tools = $('<div class="zoomifyc-tools"></div>'),
			$prev2 = $('<span class="prev" title="Prev">&lt;</span>'),
			$next2 = $('<span class="next" title="Next">&gt;</span>'),
			$leftRotate = $('<span class="left-rotate" title="Rotate Left"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAABJUlEQVQ4y6WRsSuEcRjHP897KEqmK5NSJ4tISdkswmJQJhOjyWJisZoNyj8gpbNYLP4Hug2L4VJM5wYpH4M3vXfdubv3vuPzfJ/P7/k+P+ggdbiTp6PUO3VPHegHcu+vKupaL4OJupRuULVRF+pg1p80DYe6C9wCy8Az8JGxlIGjiPhq9/qQeqnuZ/OncSrqSjcRztXVFvWNro6qrqvHua+fQq7V0bzziVoEahFRyw0BZoCHfpIkwAiN35gL8gqM5xlWD9XFJI0ym3OJBaCSRMQn8KaWetxiEqhHRP2voJbVQpeAUK/UqebGlnrWCaQW1FN1u51hU71R59v059L+TrYeLYwTwAEwDTwC78AYUAKegJOIePkXks3N79cXU1A1Ir5beX8AuajeueMcwmIAAAAASUVORK5CYII="></span>'),
			$rightRotate = $('<span class="right-rotate" title="Rotate Right"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAUCAYAAABroNZJAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAAsSAAALEgHS3X78AAABJUlEQVQ4y6WRsSuEcRjHP897KEqmK5NSJ4tISdkswmJQJhOjyWJisZoNyj8gpbNYLP4Hug2L4VJM5wYpH4M3vXfdubv3vuPzfJ/P7/k+P+ggdbiTp6PUO3VPHegHcu+vKupaL4OJupRuULVRF+pg1p80DYe6C9wCy8Az8JGxlIGjiPhq9/qQeqnuZ/OncSrqSjcRztXVFvWNro6qrqvHua+fQq7V0bzziVoEahFRyw0BZoCHfpIkwAiN35gL8gqM5xlWD9XFJI0ym3OJBaCSRMQn8KaWetxiEqhHRP2voJbVQpeAUK/UqebGlnrWCaQW1FN1u51hU71R59v059L+TrYeLYwTwAEwDTwC78AYUAKegJOIePkXks3N79cXU1A1Ir5beX8AuajeueMcwmIAAAAASUVORK5CYII="></span>'),
			$close2 = $('<span title="Close">x</span>');

		$imgbox.append($close,$img);
		$switchBtn.append($prev, $next);
		$tools.append($prev2, $next2, $leftRotate, $rightRotate, $close2);
		$content.append($switchBtn, $tools, $imgbox);
		$wrap.append($shadow, $content);
		$('body').append($wrap);
		zoomifyc._content = $content;
		zoomifyc._img = $img;

		$shadow.on('click', zoomifyc.hideWrap);
		$close.on('click', zoomifyc.hideWrap);
		$close2.on('click', zoomifyc.hideWrap);
		$prev.on('click', zoomifyc.prev);
		$prev2.on('click', zoomifyc.prev);
		$next.on('click', zoomifyc.next);
		$next2.on('click', zoomifyc.next);

		$leftRotate.on('click', function() {
			zoomifyc.rotate -= 90;
			zoomifyc.setTransform(1,null,0,0);
		});
		$rightRotate.on('click', function() {
			zoomifyc.rotate += 90;
			zoomifyc.setTransform(1,null,0,0);
		});
	},
	hideWrap: function() {
		zoomifyc.isShow = false;
		$('#zoomifycWrap').hide();
		$('#zoomifycWrap .zoomifyc-img').attr('src', '');

	},
	showWrap: function(imgSrc) {
		zoomifyc.isShow = true;
		zoomifyc.reset();
		$('#zoomifycWrap').show();
		$('#zoomifycWrap .zoomifyc-img').attr('src', imgSrc);

		// è®¾ç½®å†…å®¹å—ä½ç½®
		zoomifyc.calSizeAndPosition();

		// prev/next æ˜¯å¦æ˜¾ç¤º
		zoomifyc.curIndex == 0 ? $('.zoomifyc-switch .prev').hide() : $('.zoomifyc-switch .prev').show();
		zoomifyc.curIndex == zoomifyc.allImage.length - 1 ? $('.zoomifyc-switch .next').hide() : $('.zoomifyc-switch .next').show();

	},
	reposition: function(){
		if (!zoomifyc.isShow) return;
		zoomifyc.calSizeAndPosition();
	},
	prev: function(){
		if (zoomifyc.curIndex == 0) return;
		zoomifyc.allImage.eq(zoomifyc.curIndex - 1).trigger('click');
	},
	next: function(){
		if (zoomifyc.curIndex == zoomifyc.allImage.length - 1) return;
		zoomifyc.allImage.eq(zoomifyc.curIndex + 1).trigger('click');
	},
	calSizeAndPosition: function(d){
		var $image = zoomifyc.curImage;
		var	nWidth_  = $image[0].naturalWidth || +Infinity, // å›¾ç‰‡æœ¬èº«å®½åº¦ nature
			nHeight_ = $image[0].naturalHeight || +Infinity,// å›¾ç‰‡æœ¬èº«é«˜åº¦
			nWidth = d == 'odd' ? nHeight_ : nWidth_, // å›¾ç‰‡å±•ç¤ºæ—¶çš„å®½åº¦ï¼ˆä¸»è¦æ˜¯æ—‹è½¬æƒ…å†µä¸‹ï¼Œ90*oddæ—¶å®½é«˜ç¿»è½¬ï¼‰
			nHeight = d == 'odd' ? nWidth_ : nHeight_, // å›¾ç‰‡å±•ç¤ºæ—¶çš„é«˜åº¦
			wWidth  = $(window).width(), // çª—å£å®½åº¦
			wHeight = $(window).height(),// çª—å£é«˜åº¦
			aWidth  = Math.min(nWidth, wWidth * 0.98), // é€‚é…çª—å£çš„å®½åº¦ï¼ˆå¤§äºŽçª—å£å®½åº¦åˆ™å–98%ï¼Œå¦åˆ™å–å›¾ç‰‡æœ¬èº«å®½åº¦ï¼‰
			aHeight = Math.min(nHeight, wHeight * 0.98), // é€‚é…çª—å£çš„é«˜åº¦ adapt
			scaleX  = aWidth / nWidth,
			scaleY  = aHeight / nHeight,
			scale   = Math.min(scaleX, scaleY); // å–å°çš„å€æ•°ï¼Œç¡®ä¿å®½é«˜éƒ½ä¸ä¼šè¶…å‡ºçª—å£

		// console.log('nheight,wHeight,aHeight',nHeight,wHeight,aHeight);
		// console.log('nwidth,wWidth,aWidth',nWidth,wWidth,aWidth);
		$('#zoomifycWrap .zoomifyc-imgbox').css({
			'width': nWidth * scale,
			'height': nHeight * scale
		});
		$('#zoomifycWrap .zoomifyc-content').css({
			'height': $(window).height(),
			'top': $(document).scrollTop()
		});
	},
	setTransform: function(s, r, x, y){
		if (s) zoomifyc.scale = s;
		if (r != undefined || r != null ) zoomifyc.rotate = r;
		if (x != undefined || x != null) zoomifyc.translateX = x;
		if (y != undefined || y != null) zoomifyc.translateY = y;

		var v = 'scale(' + zoomifyc.scale + ') translateX(' + zoomifyc.translateX + 'px) translateY(' + zoomifyc.translateY + 'px) rotate(' + zoomifyc.rotate + 'deg)';
		// console.log(v);
		zoomifyc._img.css({
			'-webkit-transform': v,
			'-moz-transform': v,
			'-ms-transform': v,
			'-o-transform': v,
			'transform': v,
			'transform-origin': 'center center'
		});
	},
	initMouseScroll: function(){
		var isFirefox = navigator.userAgent.indexOf("Firefox") > -1 ;
		var MOUSEWHEEL_EVENT = isFirefox ? "DOMMouseScroll" : "mousewheel";

		if(document.attachEvent){
			zoomifyc._content[0].attachEvent("on"+MOUSEWHEEL_EVENT, function(e){
				mouseWheelScroll(e);
			});
		} else if(document.addEventListener){
			zoomifyc._content[0].addEventListener(MOUSEWHEEL_EVENT, function(e){
				mouseWheelScroll(e);
			}, false);
		}


		function mouseWheelScroll(e){
			zoomifyc._preventDefault(e); // é˜»æ­¢é»˜è®¤çš„é¡µé¢æ»šåŠ¨
			var _delta = parseInt(e.wheelDelta || -e.detail);

			if (_delta > 0) {// å‘ä¸Šæ»šåŠ¨
				zoomifyc.biggerImage();
			}
			else {// å‘ä¸‹æ»šåŠ¨
				zoomifyc.smallerImage();
			}
		}
	},
	biggerImage: function(){
		zoomifyc.scale += 0.1;
		if (zoomifyc.scale >= 15)  {
			zoomifyc.scale = 15;
			return;
		}

		zoomifyc.setTransform();

		// å›¾ç‰‡æ”¾å¤§åˆ°è¶…å‡ºçª—å£æ—¶ï¼Œåˆå§‹åŒ–æ‹–æ‹½æ•ˆæžœ
		// if ($(window).height() <= zoomifyc._img.height()*zoomifyc.scale || $(window).width() <= zoomifyc._img.width()*zoomifyc.scale) {
		// 	zoomifyc._img.css('cursor', 'grab') //grabbing
		// 	initGrap();
		// }
	},
	smallerImage: function(){
		zoomifyc.scale -= 0.1;
		if (zoomifyc.scale <= 0.1)  {
			zoomifyc.scale = 0.1;
			return;
		}

		zoomifyc.setTransform();
	},
	initGrap: function(){
		var startX = 0, // å½“å‰é¼ æ ‡xåæ ‡
			startY  = 0, // å½“å‰é¼ æ ‡yåæ ‡
			translateX_ = 0, // æ‹–æ‹½å¼€å§‹æ—¶å›¾ç‰‡çš„æ°´å¹³å¹³ç§»
			translateY_ = 0, // æ‹–æ‹½å¼€å§‹æ—¶å›¾ç‰‡çš„åž‚ç›´å¹³ç§»
			bar = zoomifyc._img, // è§¦å‘æ‹–æ‹½çš„æŒ‡å®šåŒºåŸŸ
			ele = zoomifyc._img; // æ‹–æ‹½ç§»åŠ¨çš„å…ƒç´ 

		// é¼ æ ‡æŒ‰ä¸‹æ—¶è§¦å‘
		bar.on('mousedown', function (e) {
			zoomifyc.grabbing = true;
			if (!e) {
				e = window.e;
				bar.onselectstart = function () { // é˜»æ­¢IEæ–‡å­—é€‰ä¸­é»˜è®¤äº‹ä»¶
					return false;
				}
			}
			startX = e.clientX;
			startY = e.clientY;
			translateX_ = zoomifyc.translateX;
			translateY_ = zoomifyc.translateY;
		});
		// é¼ æ ‡æ¾å¼€æ—¶è§¦å‘
		$(document).on('mouseup', function () {
			zoomifyc.grabbing = false;
			translateX_ = zoomifyc.translateX;
			translateY_ = zoomifyc.translateY;
		});
		// é¼ æ ‡æŒ‰ä¸‹ç§»åŠ¨æ—¶è§¦å‘
		$(document).on('mousemove', function (event) {
			var e = event ? event : window.event;
			if (zoomifyc.grabbing) {
				var nowX = e.clientX; // å½“å‰é¼ æ ‡åæ ‡
				var nowY = e.clientY; // å½“å‰é¼ æ ‡åæ ‡
				var disX = nowX - startX;
				var disY = nowY - startY;

				zoomifyc.translateX = translateX_ + disX;
				zoomifyc.translateY = translateY_ + disY;
				// console.log(translateX_, disX, zoomifyc.translateX);
				zoomifyc.setTransform();

				zoomifyc._preventDefault();
				return false;
			}
		});
	},
	initPageEvent: function(){
		// è°ƒæ•´çª—å£ - ç¼©æ”¾å›¾ç‰‡è¿›è¡Œé€‚é…
		$(window).on('resize', zoomifyc.reposition);

		// é¡µé¢æ»šåŠ¨ - ä¿è¯æ”¾å¤§çš„å›¾ç‰‡åœ¨å½“å‰å¯è§†åŒºåŸŸçš„ä¸­å¤®
		$(document).on('scroll', zoomifyc.reposition);

		// ç›‘å¬é”®ç›˜æŒ‰é”®
		$(document).on('keydown', function(e){
			e = e || window.event;
			zoomifyc._preventDefault(e); // é˜»æ­¢ä¸Šä¸‹é”®çš„é»˜è®¤æ»šåŠ¨äº‹ä»¶
			if (e.keyCode && zoomifyc.isShow) {
				// console.log(e.keyCode);

				//é”®ç›˜å·¦å³æ–¹å‘é”® å’Œ wasdå­—æ¯æŒ‰é”®
				if(e.keyCode == 37 || e.keyCode == 65 ){ // left A
					zoomifyc.prev();
				}
				if(e.keyCode == 39 || e.keyCode == 68 ){ // right D
					zoomifyc.next();
				}
				if(e.keyCode == 38 || e.keyCode == 87 ){ // top W
					zoomifyc.biggerImage();
				}
				if(e.keyCode == 40 || e.keyCode == 83 ){ // down S
					zoomifyc.smallerImage();
				}

				// escæŒ‰é”®
				if (e.keyCode == 27) {
					if (zoomifyc.isShow) {
						// è‹¥å¤„äºŽç¼©æ”¾ã€æ—‹è½¬ã€å¹³ç§»æ—¶ï¼Œæ¢å¤åˆå§‹å€¼
						if (zoomifyc.scale != 1 || zoomifyc.rotate != 0 || zoomifyc.translateX != 0 || zoomifyc.translateY != 0) {
							zoomifyc.reset();
						}
						// é€€å‡ºå›¾ç‰‡å¼¹çª—
						else {
							zoomifyc.hideWrap();
						}
					}
				}
				// å­—æ¯ræŒ‰é”® - æ—‹è½¬
				if (e.keyCode == 82) {
					zoomifyc.rotate += 90;
					zoomifyc.setTransform(1,null,0,0);
				}
			}
		});
	},
	/** é˜»æ­¢é»˜è®¤äº‹ä»¶ï¼ˆå…¼å®¹ieï¼‰ */
	_preventDefault: function(e){
		if (e && e.preventDefault) {
			e.preventDefault();
		}
		else { // ie
			window.event.returnValue = false;
		}
		return false;
	},


}


var Util = {};
Util = {
	oddOReven: function(n){
		n = parseInt(n)
		if (n%2 == 0) return 'even';
		else return 'odd';
	}
}

function getCss(key) {
    return $('.zoomifyc-img').css(key);
}